<template>
  <div class="wrapper">
    <div class="nav-list-wrap">
      <div class="nav-list">
        <div
          class="nav"
          v-for="(item,index) in allList"
          :key="index"
          @mouseover="hoverIndex = index"
          @mouseout="hoverIndex=-1"
        >
          <router-link  class="nav-link"  :to="{name:'auctionlist',query:{id:item.id,name:item.name}}">
            <span>{{item.name}}</span>
            <i class="el-icon-arrow-right"></i>
          </router-link>


          <transition name="el-fade-in">
            <div class="shop-list-wrap"  v-show="item.child && item.child.length">
              <div class="shop-list" v-show="hoverIndex==index" @mouseover="hoverIndex = index">
                <div class="shop-ul" v-show="item.child && item.child.length">
                  <div v-for="(product,ulIndex) in item.child" :key="ulIndex" class="shop">
                    <router-link :to="{name:'auctionlist',query:{id:product.id,name:product.name}}" @click.native="hideList">
                      <img v-lazy="product.image_url" alt class="shop-img" :key="product.image_url">
                      <span class="shop-text">{{product.name}}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AllClassify",
  components: {},
  props: {},
  data() {
    return {
      allList: [],
      hoverIndex: -1
    };
  },
  watch: {},
  computed: {},
  methods: {
    //获取所有商品分类
    categories() {
      this.$api.categories().then(res => {
        if (res.status) {
          this.allList = res.data;
        }
      });
    },
    hideList(){
      this.hoverIndex=-1
    }
  },
  created() {
    this.categories();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrapper {
  position: relative;
  .nav-list-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 236px;
    height: 440px;
    background: rgb(227, 227, 227,.8);
    // background: #f8f8f8;
    border: 1px solid #E3E3E3;
    z-index: 99;
    .nav-list {
      position: relative;
      .nav a.nav-link {
        width: 234px;
        height: 49px;
        padding: 0 20px 0 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // color: #fff;
        color: #000;
        box-sizing: border-box;
        position: relative;
        &:hover {
          background: $theme-color;
          color: #fff;
        }
        span {
          display: inline-block;
          height: 20px;
          line-height: 20px;
        }
      }

      .shop-list-wrap {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 234px;
        height: 440px;
        background: transparent;
        overflow: hidden;
        .shop-list {
          min-width:265px;
          background: #fff;
          border-left: 0;
          -webkit-box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
          display: flex;
          flex-flow: row nowrap;
          &.active {
            display: block;
            z-index: 20;
          }
          .shop-ul {
            height: 440px;
            writing-mode: vertical-lr;
            border: 1px solid $border;
            .shop {
              display: block;
              float: left;
              writing-mode: horizontal-tb;
              position: relative;
              width: 265px;
              height: 73px;
              line-height: 73px;
              a {
                display: block;
                text-align: left;
                width: 100%;
                height: 100%;
                padding: 18px 20px;
                line-height: 40px;
                color: #333;
                -webkit-transition: color 0.2s;
                transition: color 0.2s;
                box-sizing: border-box;
                &:hover {
                  color: $theme-color;
                }
                img {
                  display: inline-block;
                  width: 35px;
                  height: 35px;
                  object-fit: contain;
                  margin-right: 12px;
                  vertical-align: middle;
                }
                .text {
                  line-height: 40px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>